// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__3TZmB","label":"styles_label__2-cEf"};